/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import DLTTextField from '@shared/components/form/DLTTextField';
import { useForm } from 'react-hook-form';
import DLTAutocomplete from '@shared/components/form/DLTAutocomplete';
const countries = require('i18n-iso-countries');
const enLocale = require('i18n-iso-countries/langs/en.json');
countries.registerLocale(enLocale);
const countryList = Object.entries(countries.getNames('en', { select: 'official' })).map(([code, name]) => ({
    value: code,
    label: name,
}));
const formSchema = yup.object({
    legal_entity_company_name: yup.string().required(),
    legal_entity_based_in: yup.string(),
    legal_entity_identifier: yup.string(),
});
const LegalEntityForm = (props) => {
    const { control, formState, handleSubmit } = useForm({
        resolver: yupResolver(formSchema),
    });
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
        React.createElement(Typography, { variant: 'subtitle2' }, "Legal Entity Information"),
        React.createElement(Typography, { variant: 'caption' }, "Please provide information about the company or organization that sent this deposit:"),
        React.createElement(Box, { component: 'form', sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
            React.createElement(DLTTextField, { control: control, name: 'legal_entity_company_name', label: 'Company/Organization Name' }),
            React.createElement(DLTAutocomplete, { options: countryList, control: control, name: 'legal_entity_based_in', label: 'Based in (Country)' }),
            React.createElement(DLTTextField, { control: control, name: 'legal_entity_identifier', label: 'Legal Entity Identifier (LEI) (Optional)' })),
        React.createElement(LoadingButton, { loading: props.loading, disabled: !formState.isValid, variant: 'contained', onClick: handleSubmit(props.onNext) }, "Submit"),
        React.createElement(Button, { variant: 'outlined', onClick: () => {
                props.onBack();
            } }, "Back")));
};
export default LegalEntityForm;
